export default {
    // 消息中间件资源类型查询接口
    getAllAuthType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getAllAuthType', params, response);
    },
    // 获取所有资源类型
    getAllResType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/getAllResType', params, response);
    },
    // 消息中间件资源类型查询接口
    getAllAuthTypeByResId(params, response) {
        // window.vue.$apiAxios.postRequestBody('/role/getAllAuthTypeByResId', params, response)
        window.vue.$apiAxios.get('/auth/role/getAllAuthTypeByResId', params, response);
    },
    // 资源列表
    listPermissionInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/getRoleResTypeList', params, response);
    },
    // 消息中间件删除接口
    deletePermissionInfo(params, response) {
        window.vue.$apiAxios.get('/auth/role/deletePermissionInfo', params, response);
    },
    // 消息添加接口
    insertPermissionInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/insertPermissionInfo', params, response);
    },
    // 消息添加接口
    getResInfoByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/getResInfoByName', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    deleteResInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/deleteResInfo', params, response);
    }
};
